import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionApiSvc } from '../services/api.services/session.api.svc';
import { Router } from '@angular/router';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private readonly sessionApiService: SessionApiSvc, private readonly router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !/newapi\/external/.exec(error.url) && !/login/.exec(this.router.url) && !/\/usersessioninfo/.exec(error.url)) {
          this.sessionApiService.expiredSessionMessage();
          return throwError(error);
        } else {
          return throwError(error);
        }
      })
    )
  }
}
